<template>
  <v-container class="py-0">
    <v-row dense>
      <v-col align="center" class="mt-12 mb-3" cols="12"
             justify="center">
        <h4 class="archetype-title">Archetyp definieren</h4>

        <fin-archetype-target-matrix v-model="classification"
                                     :archetype-classifications="archetypeClassifications"
                                     :individual="individual"
                                     style="font-weight: 600"/>
      </v-col>
    </v-row>

    <!-- before an archetype has been suggested -->
    <v-row v-if="similarArchetype === null"
           :class="['mt-3', 'fin-color-pale-grey']"
           dense
           style="background-color: #ededf1">
      <v-col :align="$vuetify.breakpoint.smAndUp ? 'right' : 'center'"
             class="pt-8" cols="12" sm="3">
        <v-img :height="165"
               :src="require('@/assets/archetypes/individual.svg')"
               :width="150"
               contain
               v-style:marginTop="$valueByBreakpoint({xs: '0', sm: '0', md: '0', lg: '0', xl: '0'})"/>
      </v-col>
      <div class="triangle-down"></div>
      <v-col :align="$vuetify.breakpoint.mdAndUp ? 'left' : 'center'"
             :class="$vuetify.breakpoint.smAndUp ? 'pt-12 ' : ''" cols="12"
             sm="9">
        <h4 class="personlize-title pb-3">Individualisiere die Matrix</h4>
        <fin-lexicon-text auto-solve
                          text="Klicke für jede Kategorie die Ausprägung eines Merkmals auf der Matrix an die deiner Einschätzung entspricht und finde so den zu dir passenden Archetyp."/>
      </v-col>
    </v-row>

    <!-- display the suggested archetype -->
    <v-row v-else :class="['mt-3', 'fin-color-pale-grey']"
           dense
           style="background-color: #ededf1">
      <v-col class="pt-8" cols="12" sm="5"
             :align="$vuetify.breakpoint.mdAndUp ? 'right' : 'center'">
        <v-img :height="165"
               :src="require('@/assets' + similarArchetype.img)"
               :width="150"
               contain
               v-style:marginTop="$valueByBreakpoint({xs: '0', sm: '0', md: '0', lg: '0', xl: '0'})"/>
      </v-col>
      <v-col class="pt-12" cols="12" sm="6"
             :align="$vuetify.breakpoint.mdAndUp ? 'left' : 'center'">
        <h4 class="mb-4"> <fin-lexicon-text auto-solve :text="similarArchetype.title" /></h4>
        <fin-lexicon-text class="mb-4" auto-solve :text="similarArchetype.description" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinArchetypeTargetMatrix from '@/components/pages/onboarding/ArchetypeTargetMatrix'
import FinLexiconText from '@/components/common/lexicon/LexiconText/index'
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'fin-archetype-matrix',
  components: {FinLexiconText, FinArchetypeTargetMatrix},
  props: {
    individual: {
      type: Boolean,
      default: true
    },
    initialClassification: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      classification: {
        investmentObjective: null,
        investmentHorizon: null,
        attitudeToRisk: null,
        levelOfKnowledge: null,
        timeIntensity: null,
        activeLevel: null
      },
      similarArchetype: null
    }
  },
  computed: {
    ...mapState('archetype', ['archetypeClassifications']),
    ...mapGetters('archetype', ['archetypeFinder']),
  },
  mounted() {
    if (this.initialClassification) {
      this.classification = this.initialClassification
    }
  },
  watch: {
    classification: {
      /**
       * Iterates all archetypes and compares them with the created matrix.
       * Calculates the differences per archetype and returns the first similar archetype with minimal difference.
       *
       * @returns {Object} First similar archetype
       */
      handler() {
        this.similarArchetype = this.archetypeFinder.find(Object.values(this.classification))
        this.$emit('change', {
          archeType: this.similarArchetype,
          classification: this.classification,
          individual: true
        })
      },
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
.archetype-title {
  font-family: $body-font-family;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional styling */
  margin-bottom: 12px;
}

.personlize-title {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
  /* additional styling */
}

.triangle-down {
  width: 0;
  height: 0;
  border-left: 25px solid transparent;
  border-right: 25px solid transparent;
  border-top: 50px solid white;
  position: absolute;
  clip-path: polygon(50% 35%, 0 0, 100% 0);
  left: 50%;
  margin-left: -25px;
  margin-top: -1px;
}

.ie .triangle-down {
  border-top: 20px solid white !important;
  margin-top: -7px !important;
}

.edge .triangle-down {
  border-top: 20px solid white !important;
}

h4 {
  font-family: $body-font-family;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  color: $fin-color-primary-dark;
}

::v-deep button span {
  pointer-events: none;
}
</style>
